<template>
  <div>
    <multiselect
      v-model="country"
      class="custom-multiselect-input"
      :placeholder="translations[language][PLACEHOLDER_COUNTRY]"
      label="text"
      track-by="value"
      :options="countriesOptions"
      @input="updateCountry"
    />

    <div class="btn-next">
      <button @click="next">{{ parseTranslation(NEXT) }}</button>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import { mapActions } from 'vuex'

import * as translationQuotaPanel from './StepOne.translations'

const { default: translations, ...translationKeys } = translationQuotaPanel

export default {
  props: {
    countriesOptions: {
      required: true,
    },
  },

  components: { Multiselect },

  data() {
    return {
      translations,
      ...translationKeys,
      country: {
        value: 'AR',
        text: 'Argentina',
      },
    }
  },

  methods: {
    ...mapActions(['setStep', 'setCountry']),

    next() {
      this.setStep(2)
      this.setCountry(this.country)
    },

    updateCountry(data) {
      this.setCountry(data)
    },
  },
}
</script>

<style lang="scss" scoped>
.custom-multiselect-input {
  width: 300px;
  margin-top: 20px;
}
.choose-drop {
  margin-top: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #fff;
  border-radius: 3px;
  padding: 10px;
  cursor: pointer;
  @include tipography(16);
  img {
    width: 11px;
    height: 11px;
  }
  .light & {
    border: 1px solid $gray-5;
    color: $gray-6;
  }
}

.btn-next {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
  button {
    @include tipography(16);
    background: $main;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    border-radius: 3px;
    border: none;
    padding: 5px 20px;
    cursor: pointer;
    transition: all 0.3s ease;
    &:hover {
      background: $gray-7;
    }
  }
}
</style>
